export const identityFormater = (value) => value;

export const msFormater = (value) => new Date(Number.parseInt(value, 10))
  .toLocaleString().replace(',', '');

export const numberFormater = (value) => {
  if (typeof value !== 'number') return value;
  return `${Number((value).toPrecision(14))}`;
};

export default function TabularFormater(type, value) {
  const formatTo = {
    ms: msFormater,
    string: identityFormater,
    number: numberFormater,
    raw: identityFormater,
  };

  if (!formatTo[type]) {
    return value;
  }

  const display = value?.display;
  return {
    raw: value.raw,
    display: formatTo[type](display),
  };
}
